import React, { Component } from 'react'
import { Link } from '@reach/router';
import { wobblyLineProps } from 'src/pages/slide';
import { analyticsService } from "src/services/AnalyticsService";

import "./PageFooter.scss";

export class PageFooter extends Component {
  onClickMail() {
    analyticsService.event({
      category: 'Footer',
      action: 'link',
      label: 'email',
    });
  }
  onClickResources() {
    analyticsService.event({
      category: 'Footer',
      action: 'link',
      label: 'resources',
    });
  }
  render() {
    return (
      <footer className="PageFooter" {...wobblyLineProps(this.props)}>
        <a href="mailto:designthinking@absa.africa" onClick={e=> this.onClickMail()}>designthinking@absa.africa</a> <Link to="/resources" onClick={e => this.onClickResources()}>Resources</Link>
      </footer>
    )
  }
}
